import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { asStyledComponent } from '@clds/component-enhancer';
import { typography } from '@clds/typography';
export const StyledGroupHeader = styled.div `
  ${({ size, tone }) => typography[size][tone]};
  padding: ${(props) => props.theme.spacing.xs}
    ${(props) => props.theme.spacing.sm};
`;
export const GroupHeader = asStyledComponent((props) => (_jsx(StyledGroupHeader, { size: "sm", tone: "lowContrast", ...props })));
